import type { BuiltinColorPalette } from '@visactor/vchart';

export const palette: Partial<BuiltinColorPalette> = {
  /** 背景色 */
  backgroundColor: 'rgb(12,9,41)',

  /** 轴字色 */
  axisLabelFontColor: 'rgb(255, 255, 255)',

  /** 轴网格线颜色 */
  axisGridColor: 'rgb(255, 255, 255)'
};
